module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "element element-bodymatter element-container-single element-type-prologue element-with-heading",
    attrs: {
      "epub:type": "prologue",
      "id": "prologue",
      "role": "doc-prologue"
    }
  }, [_c('div', {
    staticClass: "heading heading-container-single heading-size-full heading-format-full heading-alignment-flexible heading-without-image"
  }, [_c('div', {
    staticClass: "heading-contents"
  }, [_c('div', {
    staticClass: "title-subtitle-block title-block-without-element-number"
  }, [_c('div', {
    staticClass: "element-number-block"
  }), _vm._v(" "), _c('div', {
    staticClass: "title-block"
  }, [_c('h1', {
    staticClass: "element-title case-upper"
  }, [_vm._v("PROLOGUE")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "text",
    attrs: {
      "id": "prologue-text"
    }
  }, [_c('p', {
    staticClass: "first first-in-chapter first-full-width"
  }, [_vm._v("The door opened with a jolt. The uniformed attendant strode to the bedside where a figure lay, swallowed up by pillows and blankets. The patient’s snowy mane of hair was just a shade off from the dirty white of the linens. At Blue Plains Home for the Indigent and Infirm, finances did not allow for fresh sheets and pillowcases as often as needed.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“How are we feeling today, missy?” the attendant barked. “Time for some more medicine?”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“Where…where am I?” The patient’s faded cornflower blue eyes gazed around the room taking in the barred window with paint chipping around the frame and the single bulb hanging out of the ceiling. She heard clattering sounds in the hall followed by screams and yelling but her legs seemed stuck. They would not move for her to get up and see what was happening. It must be a hospital of some sort but the patient in the bed could not remember how she got here…")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“Oh, don’t play those games with me again, Blanche. You know perfectly well where you are. Blue Plains. One of the finest addresses in the city!” The last bit was said with a loud guffaw.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Blanche furrowed her brow and thought hard. Blue Plains? Blue Plains? But that was a poor house.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("As the attendant rolled her one way and the other to straighten her bedding, she asked weakly, “But how did I get here?”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("The woman shrugged. “Same ways most get here, I reckon,” she said. “Paddy wagon or ambulance car.”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Relenting some, she patted Blanche on the shoulder. “The doc will make rounds later today,” she said. “You can talk to him about this. But we’ve already told you about it again and again, you know.”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“Oh…” Blanche said. She had to figure this out. She tried to remember what had happened. Had she finished? There had been so much money left to hide. She didn’t know if there had been enough time to do it justice.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3dbcbfc8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/prologue.vue
// module id = 75
// module chunks = 0